import React from "react";
import WorksCarousel from "./WorksCarousel";
import "./Works.css";

import work1 from "../assets/work1.jpg";
import work2 from "../assets/work2.jpg";
import work3 from "../assets/work3.jpg";
import work4 from "../assets/work4.jpg";
import work5 from "../assets/work5.jpg";


const worksData = [
  {
    text: "Enhanced a bookstore’s digital experience with better design and search, boosting retention and sales.",
    images: [work1, work2],
  },
  {
    text: "Optimized a healthcare platform with faster performance and improved reliability, enhancing patient experience and operational efficiency.",
    images: [work3, work4],
  },
  {
    text: "Strengthened a bakery brand’s digital presence with creative visuals and strategic branding, boosting engagement and customer retention.",
    images: [work5]
  },
];

const Works = () => {
  return (
    <div className="works-container">
      {worksData.map((item, index) => (
        <div
          key={index}
          className={`work-row ${index % 2 !== 0 ? "reverse" : ""}`}
        >
          <div className="work-text">
            <p>{item.text}</p>
          </div>

          <WorksCarousel images={item.images} />
        </div>
      ))}
    </div>
  );
};

export default Works;
